import { Badge, badgeVariants } from '@repo/ui/components/badge';
import { VariantProps } from 'class-variance-authority';

interface StatusBadgeProps {
  status: Tournament['status'];
}

const getStatusConfig = (status: Tournament['status']): { text: string; variant: string } => {
  switch (status) {
    case 'PENDING':
      return {
        text: 'Pendiente',
        variant: 'warning',
      };
    case 'CONFIGURING_DATETIME_PHASES':
      return {
        text: 'Configurando horarios',
        variant: 'warning',
      };
    case 'OPEN_INSCRIPTIONS':
      return {
        text: 'Inscripciones abiertas',
        variant: 'info',
      };
    case 'ACTIVE':
      return {
        text: 'En curso',
        variant: 'success',
      };
    case 'FINISHED':
      return {
        text: 'Finalizado',
        variant: 'secondary',
      };
    default:
      return {
        text: 'Desconocido',
        variant: 'secondary',
      };
  }
};

const StatusBadge = ({ status }: StatusBadgeProps) => {
  const { text, variant } = getStatusConfig(status);

  return (
    <Badge variant={variant as VariantProps<typeof badgeVariants>['variant']}>
      <span>{text}</span>
    </Badge>
  );
};

export default StatusBadge;
